// extracted by mini-css-extract-plugin
module.exports = {"root":"ResponsiveHeaderImage_root__RxDeG"};